import gsap from 'gsap';
import Draggable  from 'gsap/Draggable';
gsap.registerPlugin(Draggable);

class KukunCarousel {
    constructor(carouselWrapper, parameters = {}) {
        this.boxWrapperE = carouselWrapper;
        this.boxesContainerE = this.boxWrapperE.querySelector('.k-carousel-boxes-wrapper');
        this.boxesE = this.boxWrapperE.querySelectorAll('.k-carousel-box');
        this.proxyE = document.createElement('div');
        this.windowWidth = 0;
        this.box_width = 0;
        this.box_height = 0;
        this.total_boxes = 0;
        this.total_wrapper_width = 0;
        this.carousel_animation = '';
        this.carousel_drag = '';
        this.paused = false;
        this.is_left_to_right = false;
        this.wrapVal;
        this.arrow_prev = this.boxWrapperE.querySelector('.k-carousel-arrow-prev');
        this.arrow_next = this.boxWrapperE.querySelector('.k-carousel-arrow-next');
        this.typeCarousel = parameters.type ? parameters.type : 'traditional';
        this.arrowOpacity = 0;
        // Traditional slider 
        this.prevSlide = null;
        this.currentSlide = 0;
        this.isAnimating = false;
        this.traditionalDelayedCall;
        // Simple slider
        this.dragSpeed = 1;
        this.isDown = false;
        this.startX;
        this.scrollLeft;
        this.isScrolling = false;
        this.currentScrollLeft = 0;

        let {
            //autoplay = true,
            draggable = false,
            dots = true,
            speed = this.typeCarousel == 'traditional' ? 4 : 90,
            speedBackArrow = 30,
            speedNextArrow = 30,
            boxSpacing = 30,
            arrowOpacity = 0,
            dragSpeed = 1,
            lazyLoad = false
        } = parameters;

        this.carouselOptions = {
            //autoplay: autoplay,
            draggable: draggable,
            dots: dots,
            speed: speed,
            speedBackArrow: speedBackArrow,
            speedNextArrow: speedNextArrow,
            boxSpacing: boxSpacing,
            arrowOpacity: arrowOpacity,
            dragSpeed: dragSpeed,
            lazyLoad: lazyLoad
        }

        if (this.boxesE.length > 0) {
            this.loadListeners();
            this.createSlider();
        }
    }

    createSlider() {
        this.checkWindowSize();
        this.loadOptions();
        // gsap.set([boxWrapperE, viewportE], { height: this.box_height, xPercent: -50 });
    }

    loadOptions() {
        let thisClass = this;
        if (this.typeCarousel == 'continuous') {
            gsap.set(thisClass.boxesE, {
                left: -thisClass.box_width,
                x: (i) => i * thisClass.box_width
            })
        } else if (this.typeCarousel == 'traditional') {
            gsap.set(thisClass.boxesE, {
                left: -thisClass.box_width
            });

            if (this.carouselOptions.dots) {
                this.createDots();
                this.loadDotsEvents();
            }
        }

        if (this.carouselOptions.arrowOpacity == 1) {
            this.arrow_next.style.opacity = 1;
            this.arrow_prev.style.opacity = 1;
        }

        this.createCarouselAnimation();
        if (this.carouselOptions.draggable) {
            this.createDrag();
        }

        if (this.carouselOptions.lazyLoad) {
            this.initLazyLoad();
        }
    }

    createDrag() {
        let thisClass = this;
        if (this.typeCarousel == 'continuous') {
            this.carousel_drag = Draggable.create(this.proxyE, {
                type: "x",
                trigger: thisClass.boxWrapperE,
                inertia: true,
                onDragParams: [thisClass],
                onDrag: (thisClass) => { thisClass.updateProgress(thisClass); },
                onPress: function () {
                    gsap.set(this.target, {
                        left: 0,
                        top: 0,
                        x: 0,
                        y: 0
                    })
                },
                // onThrowUpdate: updateProgress,
                onDragStart: function () {
                    if (!thisClass.is_left_to_right) {
                        thisClass.carousel_animation.kill();
                        thisClass.createCarouselAnimation('+');
                    }
                },
                snap: {
                    x: (x) => {
                        return Math.round(x / thisClass.box_width) * thisClass.box_width;
                    }
                }
            });
        }
    }

    updateProgress(thisClass) {
        thisClass.carousel_animation.progress(thisClass.wrapVal(thisClass.carousel_drag[0].x) / thisClass.total_wrapper_width);
    }

    createCarouselAnimation(dir = '-', speed = this.carouselOptions.speed, with_arrow = false) {
        let thisClass = this;
        let paused = this.carouselOptions.autoplay ? false : true;
        paused = with_arrow ? false : paused;

        if (thisClass.typeCarousel == 'continuous') {
            if (dir == '+') {
                this.is_left_to_right = true;
            } else {
                this.is_left_to_right = false;
            }

            this.carousel_animation = gsap.to(thisClass.boxWrapperE.querySelectorAll('.k-carousel-box'), {
                duration: speed,
                x: `${dir}=${thisClass.total_wrapper_width}`,
                ease: "linear",
                paused: paused,
                repeat: -1,
                modifiers: {
                    x: function (x, target) {
                        if (dir == '+') {
                            x = parseInt(x) % thisClass.total_wrapper_width;
                        } else {
                            x = parseInt(x);
                            x = x < 0 ? (x % thisClass.total_wrapper_width) + thisClass.total_wrapper_width : x;
                        }
                        target.style.visibility = x - thisClass.box_width > thisClass.windowWidth ? "hidden" : "visible";
                        return `${x}px`;
                    }
                }
            })
        } else if (thisClass.typeCarousel == 'traditional') {
            this.createTraditionalSlider(0);
            if (this.carouselOptions.autoplay) {
                this.startAutoPlay();
            }
        } else if (thisClass.typeCarousel == 'simple') {
            thisClass.boxesContainerE.addEventListener('mousedown', function(e) {
                thisClass.isDown = true;
                // thisClass.boxesContainerE.classList.add('dragging-list');
                thisClass.startX = e.pageX - thisClass.boxesContainerE.offsetLeft;
                thisClass.scrollLeft = thisClass.boxesContainerE.scrollLeft;
              });
              thisClass.boxesContainerE.addEventListener('mouseleave', function() {
                thisClass.isDown = false;
                thisClass.boxesContainerE.classList.remove('dragging-list');
              });
              thisClass.boxesContainerE.addEventListener('mouseup', function() {
                thisClass.isDown = false;
                thisClass.boxesContainerE.classList.remove('dragging-list');
              });
              thisClass.boxesContainerE.addEventListener('mousemove', function(e) {
                if(!thisClass.isDown) return;
                thisClass.boxesContainerE.classList.add('dragging-list');
                e.preventDefault();
                const x = e.pageX - thisClass.boxesContainerE.offsetLeft;
              //   const walk = (x - startX) * 3; //scroll-fast
                  const walk = (x - thisClass.startX) * thisClass.carouselOptions.dragSpeed;
                  thisClass.boxesContainerE.scrollLeft = thisClass.scrollLeft - walk;
              }); 
              for (let i = 0; i < this.boxesE.length; i++) {
                  const box = this.boxesE[i];
                  box.style.marginRight = `${thisClass.carouselOptions.boxSpacing}px`;
              }
              this.hiddeArrowsByScrollPosition();
        } 
    }

    goToPrevSlide() {
        let slideToGo = this.currentSlide - 1;
        if (slideToGo <= -1) {
            slideToGo = this.total_boxes - 1;
        }
        this.stopAutoPlay();
        this.createTraditionalSlider(slideToGo, "prev");
    }

    goToNextSlide() {
        let slideToGo = this.currentSlide + 1;
        if (slideToGo >= this.total_boxes) {
            slideToGo = 0;
        }
        this.stopAutoPlay();
        this.createTraditionalSlider(slideToGo, "next");
    }

    // < Traditional slider 
    createTraditionalSlider(currentSlide, _direction) {
        if (!this.isAnimating) {
            this.isAnimating = true;
            this.prevSlide = this.currentSlide;
            this.currentSlide = parseInt(currentSlide);

            let $prevSlide = this.boxesE[this.prevSlide];
            let $currentSlide = this.boxesE[this.currentSlide];
            let time = 1;
            let direction = "next";
            if (_direction) {
                direction = _direction;
            }

            if (direction == "next") {
                gsap.to($prevSlide, time, {
                    left: "-100%"
                });
                gsap.fromTo($currentSlide, time, {
                    left: "100%"
                }, {
                    left: "0"
                });
            }  else {
                gsap.to($prevSlide, time, {
                    left: "100%"
                });
                gsap.fromTo($currentSlide, time, {
                    left: "-100%"
                }, {
                    left: "0"
                });
            }

            if (this.carouselOptions.dots) {
                let current_selected_dot = this.boxWrapperE.querySelector('.k-carousel-dot-active');
                let dot = this.boxWrapperE.querySelector(`li[data-slide-to="${this.currentSlide}"]`);

                if (current_selected_dot && dot) {
                    current_selected_dot.classList.remove('k-carousel-dot-active');
                    dot.classList.add('k-carousel-dot-active');
                }
            }

            gsap.delayedCall(time, () => {
                this.isAnimating = false;
            });
        }
    }

    play(thisClass) {
        thisClass.goToNextSlide();
        gsap.delayedCall(thisClass.carouselOptions.speed, thisClass.play, [thisClass]);
    }

    startAutoPlay(immediate) {
        if (immediate != null) {
            immediate = false;
        }

        if (immediate) {
            this.goToNextSlide();
        }
        gsap.delayedCall(this.carouselOptions.speed, this.play, [this]);
    }

    stopAutoPlay() {
        this.autoplay = false;
        gsap.killTweensOf(this.play);
    }

    createDots() {
        let dots = '<ul class="k-carousel-dots-wrapper">';
        for (let i = 0; i < this.total_boxes; i++) {
            dots += `<li class="k-carousel-dot" data-slide-to="${i}"></li>`;        
        }
        dots += '</div>';
        this.boxWrapperE.insertAdjacentHTML('beforeend', dots);        
    }

    loadDotsEvents() {
        let dotElements = this.boxWrapperE.querySelectorAll('.k-carousel-dot');
        if (dotElements[0]) {
            dotElements[0].classList.add('k-carousel-dot-active');
        }
        for (let i = 0; i < dotElements.length; i++) {
            const dot = dotElements[i];
            const goTo = dot.getAttribute('data-slide-to');

            dot.addEventListener('click', (e) => {
                let direction = this.currentSlide < i ? 'next' : 'prev';

                if (!this.isAnimating) {
                    if (goTo != this.currentSlide) {
                        this.stopAutoPlay();
                        this.createTraditionalSlider(goTo, direction);
                    }   
                }
            })
        }
    }
    // Traditional slider />

    // Simple slider 
    simpleNextArrow() {
        if (this.boxesContainerE) {
          this.scrollLeft = this.boxesContainerE.scrollLeft;
          this.currentScrollLeft = this.scrollLeft + 400;
          if (!document.documentMode) { // is not IE
            this.boxesContainerE.scrollTo({
              left: this.scrollLeft + 400,
              behavior: 'smooth'
            });
          } else {
            this.boxesContainerE.scrollLeft = this.scrollLeft + 400;
          }
        }
    }

    simpleBackArrow() {
        if (this.boxesContainerE) {
          this.scrollLeft = this.boxesContainerE.scrollLeft;
          this.currentScrollLeft = this.scrollLeft - 400;
          if (!document.documentMode) { // is not IE
            this.boxesContainerE.scrollTo({
              left: this.scrollLeft - 400,
              behavior: 'smooth'
            });
          } else {
            this.boxesContainerE.scrollLeft = this.scrollLeft - 400;
          }
        }
    }

    hiddeArrowsByScrollPosition() {
        let scrollWidth = this.boxesContainerE.scrollWidth - this.boxesContainerE.scrollLeft;
        let clientWidth = this.boxWrapperE.clientWidth;

        if (this.boxesContainerE.scrollLeft == 0) {
            this.arrow_prev.style.display = 'none';
        } else {
            this.arrow_prev.style.display = 'block';
        }

        if (scrollWidth == clientWidth) {
            this.arrow_next.style.display = 'none';
        } else {
            this.arrow_next.style.display = 'block';
        }

        if ((this.total_boxes * this.box_width) <= clientWidth) {
            this.arrow_next.style.display = 'none';
        } else {
            if (scrollWidth != clientWidth) {
                this.arrow_next.style.display = 'block';
            }
        }
    }
    // Simple silder />
    checkWindowSize() {
        this.boxesE = this.boxWrapperE.querySelectorAll('.k-carousel-box');
        this.total_boxes = this.boxesE.length;
        this.windowWidth = window.screen.width;
        this.box_width = this.boxesE[0].scrollWidth + this.carouselOptions.boxSpacing;
        this.box_height = this.boxesE[0].scrollHeight;
        this.total_wrapper_width = this.box_width * this.total_boxes;
        this.wrapVal = gsap.utils.wrap(0, this.total_wrapper_width);

        if (this.typeCarousel != 'simple') {
            this.boxesContainerE.style.height = `${this.box_height + 10}px`;

            if (this.carousel_animation != '') {
                this.carousel_animation.kill();
                if (this.carouselOptions.draggable) {
                    this.carousel_drag[0].kill();
                }
                this.loadOptions();
            } 
        } else {
            this.hiddeArrowsByScrollPosition();
        }
    }

    stopPlay() {
        if (!this.paused) {
            this.paused = true;
            this.carousel_animation.pause();
        } else {
            this.paused = false;
            this.carousel_animation.play();
        }
    }


    loadListeners() {
        window.addEventListener('resize', (e) => {
            this.checkWindowSize();
        });

        if (this.typeCarousel == 'continuous') {
            this.boxesContainerE.addEventListener('mousedown', (e) => {
                gsap.set(this.proxyE, {
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0
                })
                if (!this.is_left_to_right) {
                    this.carousel_animation.kill();
                    this.createCarouselAnimation('+');
                }
                if (this.carouselOptions.autoplay) {
                    this.stopPlay();
                }
            })

            this.boxesContainerE.addEventListener('mouseleave', (e) => {
                if (this.is_left_to_right) {
                    this.carousel_animation.kill();
                    this.createCarouselAnimation('-');
                }
                if (this.carouselOptions.autoplay) {
                    this.stopPlay();
                }
                this.boxesContainerE.blur();
                this.boxWrapperE.blur();
            })

            this.arrow_next.addEventListener('mousedown', (e) => {
                this.carousel_animation.kill();
                this.createCarouselAnimation('-', this.carouselOptions.speedBackArrow, true);
            })
            this.arrow_next.addEventListener('mouseleave', (e) => {
                this.carousel_animation.kill();
                this.createCarouselAnimation('-');
            })


            this.arrow_prev.addEventListener('mousedown', (e) => {
                this.carousel_animation.kill();
                this.createCarouselAnimation('+', this.carouselOptions.speedNextArrow, true);
            })
            this.arrow_prev.addEventListener('mouseleave', (e) => {
                this.carousel_animation.kill();
                this.createCarouselAnimation();
            })
        } else if(this.typeCarousel == 'traditional') {
            this.boxesContainerE.addEventListener('mouseenter', (e) => {
                this.stopAutoPlay();
            })

            this.boxesContainerE.addEventListener('mouseleave', (e) => {
                this.startAutoPlay();
            })

            this.arrow_next.addEventListener('click', (e) => {
                this.goToNextSlide();
            })

            this.arrow_prev.addEventListener('click', (e) => {
                this.goToPrevSlide();
            })
        } else if (this.typeCarousel == 'simple') {
            this.boxesContainerE.addEventListener('scroll', (e) => {
                this.hiddeArrowsByScrollPosition();
            })

            this.arrow_next.addEventListener('click', (e) => {
                this.simpleNextArrow();
            })

            this.arrow_prev.addEventListener('click', (e) => {
                this.simpleBackArrow();
            })
        }
    }

    initLazyLoad() {
        if (!'IntersectionObserver' in window &&
            !'IntersectionObserverEntry' in window &&
            !'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
            for (let i = 0; i < this.boxesE.length; i++) {
                const box = this.boxesE[i];
                const bgUrl = box.getAttribute('k-lazybg-src');
                if (bgUrl) {
                    box.style.backgroundImage = `url(${bgUrl})`;
                }
            }
        } else {
            const lazyOptions = {
                root: null,
                rootMargin: '0px', // like css property
                threshold: 0
            }

            let lazyLoadObserver = new IntersectionObserver(setBackgroundImages, lazyOptions);
            this.boxesE.forEach(box => {
                box.classList.add('k-carousel-box-bg-lazyload');
                lazyLoadObserver.observe(box);
            });

            function setBackgroundImages(entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const bgUrl = entry.target.getAttribute('k-lazybg-src'); 
                        if (bgUrl) {
                            let bgImage = new Image();
                            bgImage.onload = () => {
                                entry.target.style.backgroundImage = `url(${bgImage.src})`;
                                entry.target.classList.remove('k-carousel-box-bg-lazyload');
                            };
                            bgImage.src = bgUrl;
                            observer.unobserve(entry.target)
                        }
                    }
                });
            }
        }
    }
}


const init = (carouselWrappers, carouselParameters) => {
    let carouselInstances = [];

    if (carouselWrappers) {        
        if (typeof carouselWrappers.length == 'undefined') {
            const htmlElement = carouselWrappers;
            carouselInstances = new KukunCarousel(htmlElement, carouselParameters);
        } else {
            for (let i = 0; i < carouselWrappers.length; i++) {
                const htmlElement = carouselWrappers[i];
                let carouselInstance = new KukunCarousel(htmlElement, carouselParameters);
                carouselInstances.push(carouselInstance);
            }
        }
    }

    return carouselInstances;
}


export {
    init
};